import React from "react";
import { NavLink, useLocation, Routes, Route, Navigate } from "react-router-dom";
import {
  UserPlus, Clock, FileText, Settings, Download, LayoutDashboard
} from "lucide-react";
import { HRProvider } from "../context/HRContext";
import HRDashboard from "../screens/HRDashboard";
import { EmployeeOnboardingScreen } from "../screens/EmployeeOnboardingScreen";
import { AttendanceScreen } from "../screens/AttendanceScreen";
import { LeavesScreen } from "../screens/LeavesScreen";
import { PaySetupScreen } from "../screens/PaySetupScreen";
import { PayslipsScreen } from "../screens/PayslipsScreen";

const tabs = [
  { key: "dashboard", label: "Overview", path: "/hr", icon: LayoutDashboard, end: true },
  { key: "onboarding", label: "Onboarding", path: "/hr/onboarding", icon: UserPlus },
  { key: "attendance", label: "Attendance", path: "/hr/attendance", icon: Clock },
  { key: "leaves", label: "Leaves", path: "/hr/leaves", icon: FileText },
  { key: "pay-setup", label: "Pay Setup", path: "/hr/pay-setup", icon: Settings },
  { key: "payslips", label: "Payslips", path: "/hr/payslips", icon: Download },
];

function HRSubNav() {
  const location = useLocation();

  return (
    <div className="bg-white border-b border-slate-200 sticky top-0 z-10 shadow-none">
      <div className="flex items-center gap-1 px-4 overflow-x-auto scrollbar-hide">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.end
            ? location.pathname === tab.path
            : location.pathname.startsWith(tab.path);

          return (
            <NavLink
              key={tab.key}
              to={tab.path}
              end={tab.end}
              className={() =>
                `flex items-center gap-2 px-4 py-3 text-[13px] font-medium border-b-2 transition-all whitespace-nowrap ${
                  isActive
                    ? "border-[#2b448f] text-[#2b448f] bg-blue-50/50"
                    : "border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-300"
                }`
              }
            >
              <Icon className="w-4 h-4 flex-shrink-0" />
              <span>{tab.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
}

export function HRLayout() {
  return (
    <HRProvider>
      <div className="flex flex-col h-full">
        {/* Module Header */}
        <div className="bg-white px-6 pt-5 pb-0 border-b-0">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 bg-[#2b448f] rounded-xl flex items-center justify-center flex-shrink-0">
              <UserPlus className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-[16px] font-bold text-slate-900 leading-tight">Human Resources</h1>
              <p className="text-[12px] text-slate-400">Employee management, attendance, leaves & payroll</p>
            </div>
          </div>
        </div>

        {/* Tab Nav */}
        <HRSubNav />

        {/* Content Area */}
        <div className="flex-1 overflow-auto p-5 bg-slate-50/60">
          <Routes>
            <Route index element={<HRDashboard />} />
            <Route path="onboarding" element={<EmployeeOnboardingScreen />} />
            <Route path="attendance" element={<AttendanceScreen />} />
            <Route path="leaves" element={<LeavesScreen />} />
            <Route path="pay-setup" element={<PaySetupScreen />} />
            <Route path="payslips" element={<PayslipsScreen />} />
            <Route path="*" element={<Navigate to="/hr" replace />} />
          </Routes>
        </div>
      </div>
    </HRProvider>
  );
}
